<template>
  <section class="data-address">
    <v-form v-model="valid">
      <v-container grid-list-xl fluid>
        <v-layout align-center>
          <v-flex xs2>
            <v-text-field
              :mask="masks.postalcode"
              ref="zipcode"
              v-model="address.zipcode"
              label="CEP"
              :rules="[validationRules.required]"
              @keypress.enter="getAddressByCEP()"
            />
          </v-flex>

          <v-flex xs2>
            <v-btn
              flat
              small
              color="accent"
              @click="getAddressByCEP()"
              :loading="loading.show && clickedButton === 'zipcode'"
            >
              <v-icon left>search</v-icon>
              Buscar CEP
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md5>
            <v-text-field
              v-model="address.street"
              label="Logradouro"
              :rules="[validationRules.required]"
            />
          </v-flex>

          <v-flex md2>
            <v-text-field
              v-model="address.number"
              label="Número"
              :rules="[validationRules.required]"
            />
          </v-flex>

          <v-flex md5>
            <v-text-field
              v-model="address.complement"
              label="Complemento"
            />
          </v-flex>

          <v-flex md4>
            <v-text-field
              v-model="address.neighborhood"
              label="Bairro"
              :rules="[validationRules.required]"
            />
          </v-flex>

          <v-flex md4>
            <v-text-field
              v-model="address.city"
              label="Cidade"
              :rules="[validationRules.required]"
            />
          </v-flex>

          <v-flex md2>
            <v-text-field
              v-model="address.state"
              label="Estado"
              :rules="[validationRules.required]"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer />
      <v-btn
        large
        flat
        :disabled="loading.show"
        to="/"
      >
        Cancelar
      </v-btn>

      <v-btn
        large
        color="success"
        @click="updateProfileAddress()"
        :loading="loading.show && clickedButton === 'updateProfileAddress'"
        :disabled="loading.show || !valid"
      >
        <v-icon left>mdi-content-save</v-icon>
        Salvar
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </section>
</template>

<script>
import masks from '@/mixins/masks';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'DataAddress',
  data() {
    return {
      address: {},
      clickedButton: '',
      masks,
      valid: false,
      validationRules,
    };
  },
  computed: {
    user() {
      this.address = this.$store.getters.user.address;
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    user() {
      this.address = this.$store.getters.user.address;
    },
  },
  methods: {
    getAddressByCEP() {
      this.clickedButton = 'zipcode';
      this.$store.dispatch('getUserCepAddress', this.$refs.zipcode.value);
    },
    updateProfileAddress() {
      this.clickedButton = 'updateProfileAddress';
      this.$store.dispatch('updateUser', { userId: this.user.id, address_attributes: this.address });
    },
  },
};
</script>

<style scoped lang="scss">
// .data-address {}
</style>



// WEBPACK FOOTER //
// src/components/account/profile/DataAddress.vue